import "./styles.css";

type toggleProps = {
    name: string;
    value: string;
    checked: boolean;
    label: string;
    returnFunc: (field: string, checked: boolean) => any;
};

function ToggleSwitch(props: toggleProps) {
    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        props.returnFunc(props.name, e.currentTarget.checked);
    };
    return (
        <>
            <div className="container">
                <div className="toggleCol1">
                    <label
                        className="label"
                        htmlFor={props.name}
                    >
                        {" "}
                        {props.label}{" "}
                    </label>
                </div>
                <div className="toggleCol2">
                    <div className="toggle-switch">
                        <input
                            type="checkbox"
                            className="checkbox"
                            name={props.name}
                            id={props.name}
                            checked={props.checked}
                            onChange={handleChange}
                            value={props.value}
                        />
                        <label
                            className="label"
                            htmlFor={props.name}
                        >
                            <span className="inner" />
                            <span className="switch" />
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ToggleSwitch;
